// Typy elementów tras
export enum RouteElementTypeEnum {
    // Zakończony odcinek trasy
    Segment = 0,
    // Postój
    Stop = 1,
    // Postój w obszarze zdefiniowanym
    AreaStop = 2,
    // Niezakończony odcinek trasy (gdy pojazd jest w trakcie jazdy)
    UnfinishedSegment = 3
}